import { GetAlertConfirmation, AlertConfirmationTypes } from "../../../helpers/constant";
import { DataField, TealSubSection } from "../components/common-components";

export const GetReferralSection = ({ referralDetails, hideDecision = false, formType }) => {

  return (
    <>
      {referralDetails && (
        <TealSubSection className="space-y-[0.0416667in]">
          <DataField
            label="Referral Reason"
            value={
              <>
                <div className="font-semibold">{referralDetails.reason}</div>
                {referralDetails.explaination && (
                  <div className="text-sm text-gray-700 mt-1">{referralDetails.explaination}</div>
                )}
              </>
            }
          />
          {hideDecision && <DataField label="Referral Details" value={referralDetails.details} />}
          <DataField label="Referral Type" value={GetAlertConfirmation(referralDetails.type)} />

          {/* existing decision field (if not hidden) */}
          {!hideDecision && <DataField label="Decision" value={referralDetails.decision} />}

          <div className="border-t border-gray-200 my-3" />

          {/* Additional fields: show decision + optional explanation. Detect Physician form robustly. */}
          {String((referralDetails && referralDetails.form) || formType || "").toLowerCase().includes("physician") ? (
            <>
              <DataField label="" value={referralDetails.decision} />
              {referralDetails.explaination && (
                <DataField label="Explanation (Optional)" value={referralDetails.explaination} />
              )}
            </>
          ) : (
            <>
              <DataField label="" value={referralDetails.decision} />
              {referralDetails.type !== AlertConfirmationTypes.EndService && (
                <DataField label="Decision" value={"Continue"} />
              )}
              {referralDetails.explaination && (
                <DataField label="Explanation (Optional)" value={referralDetails.explaination} />
              )}
            </>
          )}
        </TealSubSection>
      )}
    </>
  );
};
